<template>
  <or-layout>
    <a-row :gutter="[16, 16]" type="flex" justify="space-between">
      <a-col :span="5">
        <!--<a-button type="primary" @click="adminAdd">新增学生</a-button>-->
      </a-col>
      <a-col :span="5">
        <a-input placeholder="姓名" v-model="keywords" @keyup.enter="searchbtn">
        </a-input>
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <div>
      <a-table :dataSource="data" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
        @change="onPaginationChange" bordered>
        <a-table-column key="nickname" title="姓名" data-index="nickname" />
        <a-table-column key="mobile" title="手机号码" data-index="mobile" />
        <a-table-column key="create_time" title="注册时间" data-index="create_time" />
        <a-table-column key="status" title="状态">
          <template slot-scope="item">
            <span v-if="item.status == 1">可用</span>
            <span v-if="item.status == 0">已禁用</span>
          </template>
        </a-table-column>
        <a-table-column key="app_version" title="客户端版本" data-index="app_version" />
        <a-table-column key="active" title="操作">
          <template slot-scope="item">
            <a-button v-if="item.status == 0" @click="changeStatus({ id: item.id, status: 1 })" class="active_btn" size="small"
              type="link">启用
            </a-button>
            <a-button v-if="item.status == 1" @click="changeStatus({ id: item.id, status: 0 })" class="active_btn" size="small"
              type="link">禁用
            </a-button>
            <a-button @click="showStudentSquad(item.id)" class="active_btn" size="small" type="link">所属班级
            </a-button>
            <a-dropdown :trigger="['click']" v-if="item.status == 1">
              <a-button size="small" type="link" icon="more" />
              <a-menu slot="overlay">
                <!--<a-menu-item>-->
                <!--<a href="javascript:;" @click="setCmpus(item)">校区班级</a>-->
                <!--</a-menu-item>-->
                <a-menu-item>
                  <a href="javascript:;" @click="resetPassword({ id: item.id })">重置密码</a>
                </a-menu-item>
                <a-menu-item>
                  <a href="javascript:;" @click="adminDelBtn({ ids: item.id })">删除</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal :visible="visible" title="用户" @ok="save" @cancel="cancel">
      <a-form>
        <a-form-item v-if="!form.id">
          <a-input v-model="form.username" placeholder="登录账号" />
        </a-form-item>
        <a-form-item>
          <a-input type="hidden" v-model="form.id" />
          <a-input v-model="form.nickname" placeholder="姓名" />
        </a-form-item>
        <a-form-item>
          <a-input v-model="form.email" placeholder="邮箱" />
        </a-form-item>
        <a-form-item>
          <a-input v-model="form.mobile" placeholder="手机号码" />
        </a-form-item>
        <a-form-item v-if="!form.id">
          <a-input v-model="form.password" placeholder="登录密码" />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal :visible="campus_visible" title="设置校区班级" @ok="modalSaveCampus" @cancel="cancel">
      <a-form>
        <a-form-item>
          <a-input v-model="campusForm.user_id" type="hidden" />
        </a-form-item>
        <a-form-item>
          <a-select @change="getCampusSquad" v-model="campusForm.campus_id" placeholder="选择校区" allow-clear>
            <a-select-option v-for="(item) in campusList" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-select v-model="campusForm.squad_id" placeholder="选择班级" allow-clear>
            <a-select-option v-for="(item) in campusSquadList" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal :visible="squadList_visible" title="设置校区班级" @ok="squadList_visible = false" :destroyOnClose="true"
      :width="1000" :footer="null" @cancel="squadList_visible = false">
      <a-table :dataSource="studentSquadList" :rowKey="item => item.id" :pagination="false" :loading="loading" bordered>

        <a-table-column key="org_name" title="机构" data-index="org_name" />
        <a-table-column key="campus_name" title="校区" data-index="campus_name" />
        <a-table-column key="grade_name" title="年级" data-index="grade_name" />
        <a-table-column key="squad_name" title="班级" data-index="squad_name" />
        <a-table-column key="jion_time" title="进班时间">
          <template slot-scope="item">
            <span>{{ moment(item.jion_time * 1000).format('ll') }}</span>
          </template>
        </a-table-column>
        <a-table-column key="status" title="班级状态">
          <template slot-scope="item">
            <span v-if="item.status == 1">开班中</span>
            <span v-if="item.status == 0">已完结</span>
          </template>
        </a-table-column>

        <a-table-column key="opt" title="操作">
          <template slot-scope="item">
            <student-home-work :user_id="item.user_id" :squad_id="item.squad_id" />
          </template>
        </a-table-column>
      </a-table>
      <div style="text-align: right;margin-top: 1rem;">
        <a-button type="primary" @click="squadList_visible = false">关闭</a-button>
      </div>
    </a-modal>
  </or-layout>
</template>

<script>
import AFormItem from "ant-design-vue/es/form/FormItem";
import moment from "moment";
import StudentHomeWork from "../components/show_student_homework.vue";

export default {
  components: { AFormItem, StudentHomeWork },
  data() {
    return {
      keywords: "",
      data: [],
      pageinfo: { total: 1, current: 1, pageSize: 10, allCnt: 0 },
      loading: false,
      visible: false,
      form: {},
      campus_visible: false,
      campusForm: {
        user_id: undefined,
        campus_id: undefined,
        squad_id: undefined
      },
      campusList: [],
      campusSquadList: [],
      studentSquadList: [],
      squadList_visible: false
    };
  },
  mounted() {
    this.searchbtn();
  },
  methods: {
    showStudentSquad(user_id) {
      this.$axios
        .post("/api/user/get_user_join_squad_list", {
          data: { user_id: user_id }
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.studentSquadList = res.data;
            this.squadList_visible = true;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getCampusSquad(id) {
      let data = { campus_id: id };
      this.$axios
        .post("/api/OrgSquad/index", {
          data
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.campusSquadList = res.data.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    modalSaveCampus() {
      this.$axios
        .post("/api/User/addorg", { data: this.campusForm })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.campus_visible = false;
            this.campusForm.squad_id = undefined;
          }
        })
        .catch(err => {
          console.error(err);
        });

    },
    getCampusList() {
      this.$axios
        .post("/api/OrgCampus/get_campus_by_orgid")
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.campusList = res.data;
            this.campusForm.campus_id = res.data[0]['id'];
            this.getCampusSquad(res.data[0]['id']);
          }
        })
        .catch(err => {
          console.error(err);
        });
    },

    setCmpus(item) {
      this.getCampusList();
      this.campusForm.user_id = item.id;
      this.campus_visible = true;
    },
    changeStatus(data) {
      this.$axios
        .post("/api/User/edit", { data })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.getAdminList();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    resetPassword(data) {
      let _this = this;
      this.$confirm({
        title: "重置密码",
        content: "确认重置当前用户密码?",
        okText: "确认",
        cancelText: "取消",
        onOk: function () {
          _this.$axios
            .post("/api/User/reset_password", {
              data
            })
            .then(res => {
              if (res.code != 200) {
                console.info("修改密码出错");
              } else {
                _this.$success({
                  title: "重置密码",
                  content: "密码已经重置成功,新密码为:" + res.data.password,
                  okText: "确认",
                  cancelText: "取消"
                });
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      });
    },
    onPaginationChange(item) {
      this.pageinfo.current = item.current;
      this.getAdminList({ keyword: this.keywords });
    },
    searchbtn() {
      this.pageinfo.current = 1;
      this.getAdminList({ keyword: this.keywords });
    },
    getAdminList(data) {
      this.$axios
        .post("/api/User/index", {
          data,
          pageinfo: this.pageinfo
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.data = res.data.data;
            this.pageinfo = res.data.pageinfo;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    adminEdit(item) {
      this.form.id = item.id;
      this.form.mobile = item.mobile;
      this.form.nickname = item.nickname;
      this.form.email = item.email;
      this.visible = true;
    },

    adminAdd() {
      this.form = {};
      this.visible = true;
    },
    adminDelBtn(data) {
      let _this = this;
      this.$confirm({
        title: "删除学生",
        content: "确认删除当前学生吗?",
        okText: "确认",
        cancelText: "取消",
        onOk: function () {
          _this.$axios
            .post("/api/User/del", { data })
            .then(res => {
              if (res.code != 200) {
                _this.$error({
                  title: "错误",
                  content: res.msg,
                  okText: "确定"
                });
              } else {
                _this.getAdminList();
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      });
    },
    save() {
      this.visible = false;
      let url = "/api/User/edit";
      if (!this.form.id) {
        url = "/api/User/add"
      }
      this.$axios
        .post(url, { data: this.form })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.getAdminList();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },

    cancel() {
      this.visible = false;
      this.campus_visible = false;
    },
    moment
  }
};
</script>
<style>
.active_btn {
  margin-left: 5px;
}
</style>